<div class="card">
  <app-card-title key="project.steps.rfq.invitationPreview.provider.documents.results" />

  @if (
    isLoadingState() ||
    invitationDocumentsResource.isLoading() ||
    uploadDocumentsCategoryResource.isLoading()
  ) {
    <app-loading />
  } @else {
    @for (item of rowVM(); track item.providerTenantMappingResponse.providerTenantId) {
      <p-panel [toggleable]="true" toggler="header" [collapsed]="true">
        <ng-template #header>
          <div class="flex items-center justify-between w-full">
            <span class="font-bold">
              {{ 'common.prefix.provider' | transloco }}
              {{ item.providerTenantMappingResponse.originalName }}
            </span>
          </div>
        </ng-template>
        <ng-template #headericons let-collapsed>
          <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
        </ng-template>

        <app-provider-document-upload
          [uploadDocumentsCategory]="uploadDocumentsCategoryResource.value() ?? []"
          [documents]="item.invitationUploadDocumentResponses"
          (previewDocument)="onPreviewDocument($event)"
          (downloadDocument)="onDownloadDocument($event)"
        ></app-provider-document-upload>
      </p-panel>
      <br />
    } @empty {
      <app-no-data />
    }
  }
</div>
